module.exports = __webpack_public_path__ + "Employer Notice 08_02_2024.pdf";